define('analytics/analytics.module',['angular', './analytics.routes', './analytics.controllers', './analytics.services'], function(angular, routes, controllers) {
    'use strict';
    var mod = angular.module('com.cd.analytics', ['ngRoute', 'analytics.routes', 'analytics.services']);
    return mod;
});
